import { Link } from 'react-router-dom'
import { MebiLogo } from './ui/MebiLogo'

export default function Footer() {
  return (
    <footer className="bg-neutral-900 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Brand */}
          <div className="flex items-center">
            <MebiLogo size="md" variant="logo-text" className="text-white" />
          </div>

          {/* Legal Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/privacy-terms" 
              className="text-neutral-300 hover:text-mebi-yellow-500 transition-colors"
            >
              Điều khoản sử dụng & chính sách bảo mật
            </Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-neutral-800 mt-6 pt-6 text-center">
          <p className="text-neutral-400 text-sm">
            © 2025 MeBi Tournament Platform. Tất cả quyền được bảo lưu.
          </p>
        </div>
      </div>
    </footer>
  )
}